import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';
import { MessageService } from '@progress/kendo-angular-l10n';
import { ShareDataService } from '../../shared/services/ShareDateService';
import { LanguagesEnum, Languges } from '../../Languages';
import localeFr from '@angular/common/locales/fr';
import localeFa from '@angular/common/locales/fa';
@Component({
  selector: 'app-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['../login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectComponent {
  @Output() UpdateCredsLanguage = new EventEmitter();

  public defaultLanguage: any;

  

  constructor(public intlService: IntlService,
    public translate: TranslateService,
    private messages: MessageService,
    private _shareDataService: ShareDataService,
    public lang: Languges,
    @Inject(DOCUMENT) private document: Document
  ) {
    
  }

  ngOnInit() {
    this.defaultLanguage = this.lang.langItems.find(l => l.preposition == (localStorage.getItem("lang") ?? "en"));
    this.selectionLangChange(this.defaultLanguage.value);
    this.UpdateCredsLanguage.emit(this.defaultLanguage.value);
  }

  public selectionLangChange(value: any): void {
    this.defaultLanguage = this.lang.langItems.find(l => l.value == Number(value));
    this.updateLanguage(value);
  }

  updateLanguage(currentLang) {
    this.translate.use(this.defaultLanguage.preposition);
    localStorage.setItem("lang", this.defaultLanguage.preposition);
    registerLocaleData(this.defaultLanguage.localeData, this.defaultLanguage.preposition);
    this.SetAppDirction(parseInt(currentLang));
    (<CldrIntlService>this.intlService).localeId = this.defaultLanguage.localeId;
    this.UpdateCredsLanguage.emit(this.defaultLanguage.value);
  }

  SetAppDirction(lang: number) {
    localStorage.setItem("isRightToLeft", this.defaultLanguage.direction);

    if (lang == 1 || lang == 4) {
      this.removeStyle("creative");
      this.removeStyle("appCss");
      this.loadStyle("./assets/Theme/css/app-creative-rtl.min.css", "creativertl");
      this.loadStyle("./assets/Theme/css/app-rtl.min.css", "apprtl");
      this._shareDataService.isUserLoggedIn.next(true);
      this.messages.notify(true);
    }
    else {
      this.removeStyle("creativertl");
      this.removeStyle("apprtl");
      this.loadStyle("./assets/Theme/css/app-creative.min.css", "creative");
      this.loadStyle("./assets/Theme/css/app.min.css", "appCss");
      this._shareDataService.isUserLoggedIn.next(true);
      this.messages.notify(false);
    }
  }

  removeStyle(clienttheme: string) {
    let themeLink = this.document.getElementById(
      clienttheme
    );
    if (themeLink) {
      this.document.getElementById(clienttheme).remove();
    }
  }

  loadStyle(styleName: string, clienttheme: string) {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      clienttheme
    ) as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = clienttheme;
      style.rel = 'stylesheet';
      style.href = `${styleName}`;
      style.type = "text/css";
      head.appendChild(style);
    }
  }
}
